module.exports = __webpack_public_path__ + "img/jindo-symbol.a806cfdc.svg";